import { LFooter } from "@/components/lfooter/LFooter";
import WButton from "@/components/wbutton/WButton";
import { MainLayout } from "@/layouts/MainLayout";
import router from "next/router";

const StaticFooter = () => {
  return (
    <div className="border-t bg-ekblue border-t-white/25">
      <div className="container px-4 py-5 mx-auto lg:text-auto lg:flex-row lg:max-w-7xl">
        <div className="flex flex-col gap-5 lg:flex-row">
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Link-uri utile:</div>
            <div className="small-markdown white-markdown flex flex-col gap-2">
              <p>
                <a href="https://drimoland.ro/taramul-fermecat"> Despre noi </a>
              </p>
              <p>
                <a href="https://drimoland.ro/blog"> BLOG Drimoland </a>
              </p>
              <p>
                <a href="https://search.google.com/local/writereview?placeid=ChIJAT1nCwBnRUcRPhMhSs6lX2E">
                  {" "}
                  Lasă-ne o RECENZIE!{" "}
                </a>
              </p>
              <p>
                <a href="https://drimoland.ro/faq"> Întrebări frecvente </a>
              </p>
              <p>
                <a href="https://drimoland.ro/regulament-ordine-interioara">
                  {" "}
                  Regulament de ordine interioară{" "}
                </a>
              </p>
            </div>
          </div>
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Program:</div>
            <div className="small-markdown white-markdown flex flex-col gap-2">
              <p>L-D: 10.00-21.00</p>
            </div>
          </div>
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Tarife:</div>
            <div className="small-markdown white-markdown flex flex-col gap-2">
              <p>Copii</p>
              <ul>
                <li>Luni-Vineri: 45 lei</li>
                <li>Weekend: 75 lei</li>
              </ul>
              <hr />
              <p>Adulți</p>
              <ul>
                <li>Luni-Vineri: 10 lei</li>
                <li>Weekend: 25 lei</li>
              </ul>
              <hr />
              <ul>
                <li>
                  *în vacanțele școlare și sărbătorile legale se percepe tarif
                  de weekend
                </li>
                <li>*pot exista evenimente speciale cu prețuri diferite</li>
              </ul>
            </div>
          </div>
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Adresă:</div>
            <div className="small-markdown white-markdown flex flex-col gap-2">
              <hr />
              <ul>
                <li>Str. Orizont, nr. 23</li>
              </ul>
              <hr />
              <ul>
                <li>Ghiroda, Timiș</li>
              </ul>
              <hr />
              <ul>
                <li>drimoland@gmail.com</li>
              </ul>
              <hr />
              <ul>
                <li>+40 770 539 589</li>
              </ul>
              <hr />
            </div>
          </div>
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Suport:</div>
            <div className="small-markdown white-markdown flex flex-col gap-2">
              <p>
                <a href="https://drimoland.ro/politica-de-confidentialitate">
                  Politica privind protectia datelor cu caracter personal
                </a>
              </p>
              <p>
                <a href="https://drimoland.ro/politica-de-cookie">
                  Politica de utilizare cookie-uri
                </a>
              </p>
              <p>
                <a href="https://drimoland.ro/termeni-si-conditii">
                  Termeni și Condiții
                </a>
              </p>
              <p>
                <a href="https://anpc.ro/ce-este-sal/">
                  <img
                    src="https://edukiwischool-space-prod.fra1.digitaloceanspaces.com/SAL_PICTOGRAMA_7fde653307.png"
                    alt="SAL-PICTOGRAMA.png"
                  />
                </a>
              </p>
              <p>
                <a href="http://ec.europa.eu/consumers/odr">
                  <img
                    src="https://edukiwischool-space-prod.fra1.digitaloceanspaces.com/pictograma_SOL_2_08f8be6ff3.png"
                    alt="pictogramaSOL2.png"
                  />
                </a>
              </p>
            </div>
          </div>
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">Urmărește-ne</div>
            <div className="grid grid-cols-2 gap-4 justify-between w-20">
              <div className="cursor-pointer">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="facebook"
                  className="svg-inline--fa fa-facebook w-5 h-5"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
                  ></path>
                </svg>
              </div>
              <div className="cursor-pointer">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="instagram"
                  className="svg-inline--fa fa-instagram w-5 h-5"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                  ></path>
                </svg>
              </div>
              <div className="cursor-pointer">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="tiktok"
                  className="svg-inline--fa fa-tiktok w-5 h-5"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                  ></path>
                </svg>
              </div>
              <div className="cursor-pointer">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="far"
                  data-icon="map"
                  className="svg-inline--fa fa-map w-5 h-5"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-full mt-10 text-white/50">
          <div>Copyright © 2024 Drimoland</div>
        </div>
      </div>
    </div>
  );
};

const Custom404Page: Page = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-40 flex flex-col items-center justify-center">
        <h1 className="text-4xl font-bold text-gray-700 mb-8">
          404 - Pagina nu a fost găsită
        </h1>
        <p className="text-gray-600 mb-8">Pagina pe care o căutai nu există.</p>
        <WButton
          text="Înapoi la pagina principală"
          onClick={() => router.push("/")}
        />
      </div>
      <StaticFooter />
    </>
  );
};

Custom404Page.getLayout = (page) => (
  <MainLayout noSpacing={true} bgEkLight={true}>
    {page}
  </MainLayout>
);

export default Custom404Page;
